module.exports = __webpack_public_path__ + "static/media/nepal-team.15244710.JPG";